import { render, staticRenderFns } from "./PaginationShowing.vue?vue&type=template&id=3553c3ca"
import script from "./PaginationShowing.vue?vue&type=script&lang=js"
export * from "./PaginationShowing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports